var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgG50Kk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 1000,
    width: 1000,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "-500 -500 1000 1000",
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.number {\n\t\tfont-size:5px;\n\t\tfont-family:sans-serif;\n\t\t}\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "G50KK",
    transform: "scale(1.0, -1.0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 77.2,
    ry: 77.2,
    stroke: "black",
    strokeOpacity: 1,
    strokeWidth: 0.5,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 69.4,
    ry: 69.4,
    stroke: "black",
    strokeOpacity: 1,
    strokeWidth: 0.5,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 61.2,
    ry: 61.2,
    stroke: "black",
    strokeOpacity: 1,
    strokeWidth: 0.5,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 56.2,
    ry: 56.2,
    stroke: "black",
    strokeOpacity: 1,
    strokeWidth: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 53.2,
    ry: 53.2,
    stroke: "white",
    strokeOpacity: 1,
    strokeWidth: 0.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 45.2,
    ry: 45.2,
    stroke: "white",
    strokeOpacity: 1,
    strokeWidth: 0.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 37.2,
    ry: 37.2,
    stroke: "white",
    strokeOpacity: 1,
    strokeWidth: 0.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 29.2,
    ry: 29.2,
    stroke: "white",
    strokeOpacity: 1,
    strokeWidth: 0.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 21.2,
    ry: 21.2,
    stroke: "white",
    strokeOpacity: 1,
    strokeWidth: 0.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 13.2,
    ry: 13.2,
    stroke: "white",
    strokeOpacity: 1,
    strokeWidth: 0.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 5.2,
    ry: 5.2,
    stroke: "white",
    strokeOpacity: 1,
    strokeWidth: 0.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 2.5,
    ry: 2.5,
    stroke: "white",
    strokeOpacity: 1,
    strokeWidth: 0.3,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "G50KK_labels",
    transform: "scale(1.0, 1.0)"
  }, /*#__PURE__*/React.createElement("text", {
    x: -0.8,
    y: -72.5,
    className: "number"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    x: -0.8,
    y: -64.5,
    className: "number"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    x: -0.8,
    y: -57.5,
    className: "number"
  }, "3"), /*#__PURE__*/React.createElement("text", {
    x: -0.8,
    y: -48.5,
    className: "number",
    fill: "white"
  }, "4"), /*#__PURE__*/React.createElement("text", {
    x: -0.8,
    y: -40.5,
    className: "number",
    fill: "white"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    x: -0.8,
    y: -32.5,
    className: "number",
    fill: "white"
  }, "6"), /*#__PURE__*/React.createElement("text", {
    x: -0.8,
    y: -24.5,
    className: "number",
    fill: "white"
  }, "7"), /*#__PURE__*/React.createElement("text", {
    x: -0.8,
    y: -16.5,
    className: "number",
    fill: "white"
  }, "8"), /*#__PURE__*/React.createElement("text", {
    x: -17.5,
    y: 1,
    className: "number",
    fill: "white"
  }, "8"), /*#__PURE__*/React.createElement("text", {
    x: -25.5,
    y: 1,
    className: "number",
    fill: "white"
  }, "7"), /*#__PURE__*/React.createElement("text", {
    x: -33.5,
    y: 1,
    className: "number",
    fill: "white"
  }, "6"), /*#__PURE__*/React.createElement("text", {
    x: -41.5,
    y: 1,
    className: "number",
    fill: "white"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    x: -49.5,
    y: 1,
    className: "number",
    fill: "white"
  }, "4"), /*#__PURE__*/React.createElement("text", {
    x: -60,
    y: 1,
    className: "number"
  }, "3"), /*#__PURE__*/React.createElement("text", {
    x: -66.5,
    y: 1,
    className: "number"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    x: -74,
    y: 1,
    className: "number"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    x: -0.8,
    y: 74,
    className: "number"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    x: -0.8,
    y: 66,
    className: "number"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    x: -0.8,
    y: 60.5,
    className: "number"
  }, "3"), /*#__PURE__*/React.createElement("text", {
    x: -0.8,
    y: 50,
    className: "number",
    fill: "white"
  }, "4"), /*#__PURE__*/React.createElement("text", {
    x: -0.8,
    y: 42,
    className: "number",
    fill: "white"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    x: -0.8,
    y: 34,
    className: "number",
    fill: "white"
  }, "6"), /*#__PURE__*/React.createElement("text", {
    x: -0.8,
    y: 26,
    className: "number",
    fill: "white"
  }, "7"), /*#__PURE__*/React.createElement("text", {
    x: -0.8,
    y: 18,
    className: "number",
    fill: "white"
  }, "8"), /*#__PURE__*/React.createElement("text", {
    x: 16.5,
    y: 1,
    className: "number",
    fill: "white"
  }, "8"), /*#__PURE__*/React.createElement("text", {
    x: 24.5,
    y: 1,
    className: "number",
    fill: "white"
  }, "7"), /*#__PURE__*/React.createElement("text", {
    x: 32.5,
    y: 1,
    className: "number",
    fill: "white"
  }, "6"), /*#__PURE__*/React.createElement("text", {
    x: 40.5,
    y: 1,
    className: "number",
    fill: "white"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    x: 48.5,
    y: 1,
    className: "number",
    fill: "white"
  }, "4"), /*#__PURE__*/React.createElement("text", {
    x: 57.5,
    y: 1,
    className: "number"
  }, "3"), /*#__PURE__*/React.createElement("text", {
    x: 64.5,
    y: 1,
    className: "number"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    x: 72.5,
    y: 1,
    className: "number"
  }, "1"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG50Kk);
export default __webpack_public_path__ + "static/media/G50KK.7a273fb84cf170bd21d3e0e0ed979bd4.svg";
export { ForwardRef as ReactComponent };